import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/dentlab/src/lib/utils/cn";
import { ORGANIZATION_MENU_ITEMS } from "../organization-menu-config";

export const OrganizationMenu = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const currentPath = location.pathname;

	const isPathActive = (path: string) => {
		// For the overview page, check exact match
		if (path === "/organisation") {
			return currentPath === "/organisation";
		}
		// For administration submenu, check if any administration path is active
		if (path === "/organisation/administration") {
			return currentPath.startsWith("/organisation/administration");
		}
		// For subpages, check if the current path matches
		return currentPath === path;
	};

	return (
		<div className="flex items-center gap-1">
			{ORGANIZATION_MENU_ITEMS.map((item, index) => (
				<button
					key={index}
					onClick={() => navigate(item.path)}
					className={cn(
						"flex items-center gap-1 px-2 py-1 text-sm rounded-md transition-colors",
						isPathActive(item.path)
							? "bg-stone-200 text-gray-800 font-medium"
							: "text-gray-700 hover:bg-stone-200"
					)}
					aria-label={item.title}
				>
					<span
						className={
							isPathActive(item.path)
								? "text-gray-800"
								: "text-gray-600"
						}
					>
						{item.icon}
					</span>
					<span>{item.title}</span>
				</button>
			))}
		</div>
	);
};